export const iconFontAwesomeSecurityCarOn = (
	<i className="fa-solid fa-car-on"></i>
);
